var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5842 18.0102L5.57422 12.0002L11.5842 5.99023L12.9992 7.40423L8.39922 12.0042L12.9992 16.6042L11.5852 18.0102H11.5842ZM17.0092 18.0102L10.9982 12.0002L17.0092 5.99023L18.4232 7.40423L13.8232 12.0042L18.4232 16.6042L17.0102 18.0102H17.0092Z",
    fill: "#475A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.a2feed7f58dd26779d039e6ef56d3aa9.svg";
export { ForwardRef as ReactComponent };